import React, { useEffect, useRef, useState, useCallback, memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEllipsisV } from "react-icons/fa";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { deletequestionnaires } from "../../services/questionnairesService";
import "./QuestionnairesMain.css";
import apiClient, { getCurrentUserId } from "../../services/apiClient";
// COMPONENTS

function QuestionnairesMain() {
  const [Questionnaires, setQuestionnaires] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        const response = await apiClient.post('/questionnaires_list', { user_id: getCurrentUserId() });
        setQuestionnaires(response.data);
      } catch (error) {
        console.error("Error fetching questionnaires:", error);
      }
    };
    fetchQuestionnaires();
  }, []);

  const handleEdit = useCallback((emailId) => {
    navigate(`/edit-questionnaires/${emailId}`);
  }, [navigate]);


  const handleDelete = async (questionnairesId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
          customClass: {
        popup: 'swal-top-zindex'
      }
      });

      if (result.isConfirmed) {
        await deletequestionnaires(questionnairesId);
        setQuestionnaires(Questionnaires.filter((questionnaire) => questionnaire.id !== questionnairesId));
        Swal.fire("Deleted!", "Invoice has been deleted.", "success");
        //handleProductContentChange("Untitled Item");
      }
    } catch (error) {
      console.error(`Failed to delete Invoice with ID ${questionnairesId}:`, error);
      Swal.fire("Error", getErrorMessage(error, "Failed to delete Questionnaire."), "error");
    }
  };
  const toggleMenu = (email) => {
    setSelectedEmail(email);
    setMenuVisible(!menuVisible);
  };


  return (
    //  ================= *****  TEMPLATES BODY JSX ***** =================
    <>
      <div className='container-fluid p-lg-5 p-md-5 p-3'>
        <div className='row g-lg-5 g-md-5 g-3'>
          <div className='col-sm-12 col-md-12 col-xl-12'>
            {/* Product Templates Description about this page */}
            <div className='mb-4'>
              <h3 className='mb-1'>Questionnaires</h3>
              <p>
              Create custom Questionnaires for your clients to fill out, ensuring you gather all necessary details and preferences. These Questionnaire templates can be seamlessly added to your Proposal templates for comprehensive client engagement.
              </p>
            </div>
          </div>
          {/* ========= Create a New Product Button ========= */}
          <div className='col-sm-12 col-md-6 col-xl-4 product-items'>
            <div className='h-100 bg-white rounded p-3 shadow-sm'>
              <Link
                to='/new-questionnaires'
                id=''
                className='h-100 d-flex align-items-center justify-content-center px-2 py-5 p-urls'
                style={{ border: "1px dashed #534dbb" }}>
                <div className='mb-4 text-center'>
                  <i
                    className='fa-solid fa-plus'
                    style={{ fontSize: "70px" }}></i>
                  <h6 className='mb-0 fw-bold text-uppercase'>
                      CREATE A NEW QUESTIONNAIRE
                  </h6>
                </div>
              </Link>
            </div>
          </div>

          {/* ========= Basic Photo Booth Contract Button ========= */}
          {Questionnaires.map((Questionnaire) => (
          <div  key={Questionnaire.id}  id='' className='col-sm-12 col-md-6 col-xl-4 contact-items'>
            <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded p-4 shadow-sm position-relative' onClick={ () =>  handleEdit(Questionnaire.id)}>
              <div className='three-dot-btn'>
                <div className='position-absolute top-0 end-0 me-3 mt-2'>

                <button className='border-0 bg-transparent ' type='button'>
                <div id='p-dot' style={{ position: "relative", zIndex: 10000 }} onMouseEnter={() => toggleMenu(Questionnaire)}
  onMouseLeave={() => toggleMenu(null)} >
                <FaEllipsisV
                  
                  style={{ cursor: "pointer" }}
                />
                {menuVisible && selectedEmail === Questionnaire && (
                  <div
                    className='position-absolute bg-white shadow-sm rounded'
                    style={{
                      top: "20px",
                      right: "0",
                      zIndex: "10",
                    }}>
                    <button
                      className='dropdown-item'
                      onClick={() => handleEdit(Questionnaire.id)}>
                      Edit
                    </button>
                    <button
                      className='dropdown-item'
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(Questionnaire.id)}
                        }>
                      Delete
                    </button>
                  </div>
                )}
              </div>
              </button>


                </div>
                <div className='text-center edit-btn'>
                  {/* File With Signature Icon */}

                  <button className='border-0 bg-transparent' type='button'>
                    <i className='fa-solid fa-file-signature'></i>
                  </button>
                  <p className='basic-photo'>
                    {Questionnaire.title}
                  </p>
                </div>
              </div>
            </div>
          </div>
           ))}
          {/* ========= Product Template - END ========= */}
        </div>
      </div>
    </>

    // ================= *****  TEMPLATES BODY JSX ***** =================
  );
}

const MemoizedQuestionnairesMain = memo(QuestionnairesMain);
export { MemoizedQuestionnairesMain as QuestionnairesMain };
